import { Card, Grid, Tabs } from '@mantine/core';
import { IconCoin, IconGift, IconPalette } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import ErrorMessage from '../components/ErrorMessage';
import HeaderStatistic from '../components/HeaderStatistic';
import LoyaltyCouponsTab from '../components/Loyalty/LoyaltyCouponsTab';
import LoyaltyCustomizeTab from '../components/Loyalty/LoyaltyCustomizeTab';
import LoyaltyGrantsTab from '../components/Loyalty/LoyaltyGrantsTab';
import Metadata from '../components/Metadata';
import MetricsSelector from '../components/MetricsSelector';
import Spinner from '../components/Spinner';
import { Page } from '../constants/pageTitles';
import { dateToEndOfDay, dateToStartOfDay, daysAgoISODate, todayISODate } from '../helpers/dateUtils';
import useFetch from '../helpers/useFetch';

const tabs = ['grantRules', 'redeemRules', 'customization'];

const LoyaltyPage = () => {
  const { accountId, domainId } = useParams();
  const fetch = useFetch();

  const initialPeriodDays = 30;

  // Store ISO date strings (YYYY-MM-DD)
  const [startDate, setStartDate] = useState(daysAgoISODate(initialPeriodDays - 1));
  const [endDate, setEndDate] = useState(todayISODate());
  const [stats, setStats] = useState({});

  const [laodError, setLoadError] = useState();

  const [tab, setTab] = useState(tabs[0]);

  const STATIC_ID = 1;

  useEffect(() => {
    setStats(undefined);
    // Convert ISO date strings to full timestamps for the API
    const startTs = dateToStartOfDay(startDate, 'local');
    const endTs = dateToEndOfDay(endDate, 'local');
    fetch(
      `/api/admin/accounts/${accountId}/domains/${domainId}/loyalty/stats?startTime=${encodeURIComponent(
        startTs
      )}&endTime=${encodeURIComponent(endTs)}`
    )
      .then(({ stats }) => {
        setStats(
          Object.keys(stats).reduce((accu, statKey) => {
            accu[statKey] = { [STATIC_ID]: stats[statKey] };
            return accu;
          }, {})
        );
      })
      .catch(setLoadError);
  }, [accountId, domainId, endDate, fetch, startDate]);

  if (laodError) {
    return <ErrorMessage message={laodError.message} />;
  }

  return (
    <>
      <Metadata title={Page.loyalty} />
      <MetricsSelector
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        rowSize="12"
      />
      <Card withBorder my="md">
        {stats === undefined ? (
          <Spinner />
        ) : (
          <Grid>
            <Grid.Col span={{ base: 12, sm: 4 }}>
              <HeaderStatistic title="Points Earned" stats={stats} stat="loyaltyGrant" id={STATIC_ID} statKey="value" />
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 4 }}>
              <HeaderStatistic
                title="Points Redeemed"
                stats={stats}
                stat="loyaltyPurchase"
                percentageOfStat="autocompleteInteractions"
                id={STATIC_ID}
                statKey="value"
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 4 }}>
              <HeaderStatistic
                title="Coupons Purchased"
                stats={stats}
                stat="loyaltyPurchase"
                id={STATIC_ID}
                statKey="count"
              />
            </Grid.Col>
          </Grid>
        )}
      </Card>
      <Tabs value={tab} onChange={setTab} mb="md">
        <Tabs.List>
          <Tabs.Tab value="grantRules" leftSection={<IconCoin size={16} />}>
            Earn Points
          </Tabs.Tab>
          <Tabs.Tab value="redeemRules" leftSection={<IconGift size={16} />}>
            Redeem Points
          </Tabs.Tab>
          <Tabs.Tab value="displaySettings" leftSection={<IconPalette size={16} />}>
            Display Settings
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="grantRules">
          <LoyaltyGrantsTab />
        </Tabs.Panel>
        <Tabs.Panel value="redeemRules">
          <LoyaltyCouponsTab />
        </Tabs.Panel>
        <Tabs.Panel value="displaySettings">
          <LoyaltyCustomizeTab />
        </Tabs.Panel>
      </Tabs>
    </>
  );
};

export default LoyaltyPage;
